import { Component, OnInit } from '@angular/core';
import { ContactUsDialogComponent } from 'src/app/layout/toolbar/contact-us-dialog/contact-us-dialog.component';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { translate } from '@jsverse/transloco';
import { FaqSectionComponent } from '../faq-section/faq-section.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
    selector: 'app-faq-support-buttons',
    templateUrl: './faq-support-buttons.component.html',
    styleUrls: ['./faq-support-buttons.component.scss'],
    standalone: false
})
export class FaqSupportButtonsComponent implements OnInit {

  constructor(private sideNav: SidenavService, public authService: AuthService, public dialog: MatDialog,private router: Router) { }

  ngOnInit(): void {
  }

  onSupportClick(): void { 
    window.open('https://itsm-servicedesk.temenos.com/', '_blank');
  }

  onFaqClick(): void {
    this.router.navigate(['/',this.authService.principal.provider, 'faq']);
  }

}
